import { type FormEvent, useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { type MyGroup, groupsApi, memberToken } from "../../lib/api/groups.js";
import "./Groups.css";

export function Groups() {
  const [groups, setGroups] = useState<MyGroup[]>([]);
  const [name, setName] = useState("");
  const [copied, setCopied] = useState<string | null>(null);

  const load = useCallback(() => {
    groupsApi.listMine().then((r) => setGroups(r.success && r.data ? r.data.groups : []));
  }, []);
  useEffect(() => load(), [load]);

  async function create(e: FormEvent) {
    e.preventDefault();
    if (!name.trim()) return;
    const res = await groupsApi.create(name.trim(), "You");
    if (res.success && res.data) {
      memberToken.set(res.data.slug, res.data.member.token); // owner can add their own travel
      setName("");
      load();
    }
  }

  function copy(slug: string) {
    const url = `${window.location.origin}/g/${slug}`;
    navigator.clipboard?.writeText(url).then(() => {
      setCopied(slug);
      setTimeout(() => setCopied(null), 1500);
    });
  }

  async function remove(id: string) {
    if (!window.confirm("Delete this group? Its shared schedule is gone for everyone.")) return;
    await groupsApi.remove(id);
    load();
  }

  return (
    <section className="grp">
      <h1 className="grp__h1">Groups</h1>
      <p className="grp__lead">
        Make a shareable trip schedule. Friends add where they'll be — no account needed.
      </p>

      <form className="grp__create" onSubmit={create}>
        <input
          className="grp__input"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Group name (e.g. Lisbon summer)"
          aria-label="group name"
          maxLength={80}
        />
        <button type="submit" className="btn btn-primary" disabled={!name.trim()}>
          Create group
        </button>
      </form>

      <ul className="grp__list">
        {groups.map((g) => (
          <li key={g.id} className="grp__item">
            <div className="grp__item-main">
              <Link className="grp__name" to={`/g/${g.slug}`}>
                {g.name}
              </Link>
              <span className="grp__meta">
                {g.member_count}/{g.member_limit} people
              </span>
            </div>
            <div className="grp__actions">
              <button type="button" className="grp__btn" onClick={() => copy(g.slug)}>
                {copied === g.slug ? "Copied ✓" : "Copy link"}
              </button>
              <button
                type="button"
                className="grp__btn grp__btn-danger"
                onClick={() => remove(g.id)}
              >
                Delete
              </button>
            </div>
          </li>
        ))}
        {groups.length === 0 && (
          <p className="grp__muted">No groups yet — make your first above.</p>
        )}
      </ul>
    </section>
  );
}
